<div id="{{ widgetId }}" class="vtr-widget-hardware-scan-status" *ngIf="hasPreviousResults() && previousResultsModules">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<h2 id="{{ widgetId }}-title" role="heading" class="title">{{ 'hardwareScan.previousResult' | translate }}</h2>
				<p class="description">
					<span id="{{ widgetId }}-last-scan-text" role="text">{{ 'hardwareScan.lastScanOn' | translate }} </span>
					<span id="{{ widgetId }}-last-scan-value" role="text">{{ lastScanResultCompletionInfo.date | formatLocaleDateTime }}</span>
					<span id="{{ widgetId }}-result-text" role="text"> - {{ 'hardwareScan.result' | translate }}: </span>
					<span id="{{ widgetId }}-result-value" role="text">{{ 'hardwareScan.' + lastScanResultCompletionInfo.result.toLowerCase() | translate }}</span>
				</p>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<vtr-ui-hardware-list
				[componentId]="widgetId + '-component'"
				[items]="previousResultsModules"
				[template]="3">
			</vtr-ui-hardware-list>
		</div>
	</div>
	<div class="button-row">
		<vtr-material-button
			linkId="{{ widgetId }}-btn"
			[label]="'hardwareScan.viewDetailsLog' | translate | uppercase"
			[tooltipText] ="'hardwareScan.viewDetailsLog' | translate"
			(buttonClick)="onPreviousResults()"
			heightSize="lg">
		</vtr-material-button>
	</div>
</div>
